import axios from '@/components/helpers/axiosConfig';

const catchError = (error) => {
  let errors = null;
  if (error.response) {
    errors = error.response.data;
    if (error.response.status === 413) {
      // (Request Entity Too Large)
      errors = 'File size limit reached. Please reduce the data size and try it again with a ' +
        'smaller file.';
    }
  } else {
    errors = error;
  }
  return errors;
};

const getFormats = conversionType => new Promise((resolve, reject) => {
  axios.get(`/api/formats/${conversionType}/`)
    .then((response) => {
      resolve(response.data.options);
    })
    .catch((error) => {
      reject(catchError(error));
    });
});

const getLayers = params => new Promise((resolve, reject) => {
  axios.get('/api/layers/', {
    params,
  })
    .then((response) => {
      resolve(response.data.layers);
    })
    .catch((error) => {
      reject(catchError(error));
    });
});

const convert = data => new Promise((resolve, reject) => {
  axios.post('/api/converter/', data)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(catchError(error));
    });
});

export {
  getLayers,
  getFormats,
  convert,
};



// WEBPACK FOOTER //
// ./src/components/helpers/API.js